export default {
  title: 'Liefersoft',
  form: {
    company_id: "ID de l'entreprise",
    login: 'Identifiant',
    password: 'Mot de passe',
  },
  buttons: {
    save: 'Enregistrer',
    edit: 'Modifier',
    cancel: 'Annuler',
  },
  toasts: {
    error: "Échec de l'enregistrement des modifications",
    success: 'Modifications enregistrées',
  },
  instructions: {
    title: 'Instructions de configuration :',
    steps: {
      1: 'Allez dans « Paramètres » > « Paramètres du programme » > « API/Interfaces ».',
      2: "Ajouter une plateforme :\n• Cliquez sur le bouton « Plateformes ».\n• Saisissez un nom d'utilisateur (p. ex., le nom de la plateforme).\n• Cliquez sur « Enregistrer ».",
      3: "Copier les données API :\n• Après l'enregistrement, une fenêtre avec le code de la plateforme API s'affichera.\n• Copiez les données affichées.",
    },
  },
  connected: {
    title: 'Liefersoft est connecté',
    description: 'Cette intégration est configurée.',
  },
};
